export default __webpack_public_path__ + "static/media/gadugi-gras.84edafff.ttf";